import { FC, useCallback, useEffect } from "react";
import cn from "classnames";
import Icon from "../../brand/Icon";
import { AlertIcons, AlertProps } from "./Alert.props";
import styles from "./Alert.module.scss";
import { useAlert } from "./useAlert";

/**
 * The alert component
 * @deprecated Please use the component in `capitalrx-components-2.0/lib/general`.
 */
export const Alert: FC<AlertProps> = (props: AlertProps): JSX.Element => {
  const { testId, className: auxClassName, type = "success", style = "banner", message } = props;

  const [, hideAlert] = useAlert();

  const handleRemoveClick = useCallback(() => {
    hideAlert();
  }, [hideAlert]);

  useEffect(() => {
    const isValidType = message instanceof Error || typeof message === "string";
    if (!isValidType) {
      console.warn("An attempt was made to pass invalid data into an alert message.");
      console.warn("Only Error instances and strings are supported, but got", message);
    }
  }, [message]);

  const alertClasses = cn("alert", styles.Alert, styles[type], styles[style], auxClassName);

  const alertIcons: AlertIcons = {
    success: "check-mark-circle",
    warning: "warning",
    error: "x-circle",
    "general-turquoise": "info",
    "general-dark": "info",
    "general-grey": "info",
  };

  const removeIcon = (
    <div className={styles.removeIcon} onClick={handleRemoveClick}>
      <Icon id="alert-remove-icon" className="alert-remove-icon" name="x" color="white"></Icon>
    </div>
  );

  let messageText = "An unknown error occurred.";
  if (message instanceof Error) {
    messageText = message.message;
  } else if (typeof message === "string") {
    messageText = message;
  }

  return (
    <div data-testid={testId ? `test__${testId}` : undefined} className={alertClasses}>
      {style === "banner" && <div className={styles.pseudo} />}
      <div className={styles.messageContainer}>
        <Icon id="alert-icon" className={styles.alertIcon} name={alertIcons[type]} color="white" size="medium" />
        <span className="message">{messageText}</span>
      </div>
      {style === "banner" && removeIcon}
    </div>
  );
};
